import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchUserPreferences } from "../thunk/OperationsOverviewThunk";

const initialData: any = [];

const UserPreferenceSlice: Slice<any, {}, "UserPreferenceSlice"> = createSlice({
    name: "UserPreferenceSlice",
    initialState: { data: initialData, isLoading: false, error: "", successful :false },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchUserPreferences.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchUserPreferences.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
            state.successful = true
        });
        builder.addCase(fetchUserPreferences.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default UserPreferenceSlice